import { UseFormReturn } from 'react-hook-form'

import { WithdrawOverviewPanel } from '../components/WithdrawOverviewPanel'
import { PositionOverview } from '../logic/types'
import { TokenWithBalance, TokenWithValue } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { RiskAcknowledgementInfo } from '@/features/sparklend/common/utils/liquidation-risk-warning/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { RiskAcknowledgement } from '@/ui/organisms/risk-acknowledgement/RiskAcknowledgement'

export interface WithdrawViewProps {
  withdrawOptions: TokenWithBalance[]
  withdrawAsset: TokenWithValue
  assetsToWithdrawFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  actionsViewState: ActionsViewState
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  riskAcknowledgement: RiskAcknowledgementInfo
}

export function WithdrawView({
  withdrawOptions,
  assetsToWithdrawFields,
  form,
  actionsViewState,
  withdrawAsset,
  currentPositionOverview,
  updatedPositionOverview,
  riskAcknowledgement,
}: WithdrawViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{`Withdraw ${withdrawAsset.token.symbol}`}</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsToWithdrawFields} selectorAssets={withdrawOptions} />
        <WithdrawOverviewPanel
          withdrawAsset={withdrawAsset}
          currentPositionOverview={currentPositionOverview}
          updatedPositionOverview={updatedPositionOverview}
        />
      </FormAndOverviewWrapper>

      {riskAcknowledgement.warning && (
        <RiskAcknowledgement
          onStatusChange={riskAcknowledgement.onStatusChange}
          warning={riskAcknowledgement.warning}
        />
      )}

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
